export const FOCUS_TIMER_PRESETS = [
  { value: 25, label: '25 min' },
  { value: 50, label: '50 min' },
  { value: 0, label: 'Livre' }
];

export const FOCUS_PAUSE_REASONS = [
  'Ligação',
  'Atendimento interno',
  'Aguardando retorno',
  'Intervalo',
  'Outra interrupção'
];

export function formatTimerDuration(ms) {
  const safeMs = Math.max(Number(ms) || 0, 0);
  const totalSeconds = Math.floor(safeMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function getTimerElapsedMs(timer, now = Date.now()) {
  if (!timer) return 0;
  const accumulatedMs = Number(timer.accumulatedMs) || 0;
  if (timer.status !== 'running') return accumulatedMs;

  return accumulatedMs + Math.max(now - Number(timer.lastResumedAt || now), 0);
}

export function getTimerPauseMs(timer) {
  if (!timer) return 0;

  const pauses = Array.isArray(timer.pauses) ? timer.pauses : [];
  return pauses.reduce((total, pause) => total + (Number(pause.durationMs) || 0), 0);
}

export function getFocusTimerSnapshot(timer, now = Date.now()) {
  if (!timer) {
    return {
      isActive: false,
      elapsedMs: 0,
      remainingMs: 0,
      cycleCompleted: false,
      pauseMs: 0,
      isRunning: false,
      isPaused: false
    };
  }

  const elapsedMs = getTimerElapsedMs(timer, now);
  const plannedMs = Number(timer.durationMinutes) > 0 ? Number(timer.durationMinutes) * 60 * 1000 : 0;
  const remainingMs = plannedMs ? Math.max(plannedMs - elapsedMs, 0) : 0;
  const cycleCompleted = plannedMs > 0 && remainingMs === 0;

  return {
    isActive: true,
    elapsedMs,
    remainingMs,
    cycleCompleted,
    pauseMs: getTimerPauseMs(timer),
    isRunning: timer.status === 'running',
    isPaused: timer.status === 'paused'
  };
}

export function buildFocusSessionSummary(timer, currentUserName, now = Date.now()) {
  const snapshot = getFocusTimerSnapshot(timer, now);
  const pauses = Array.isArray(timer?.pauses) ? timer.pauses : [];
  const pausesSummary = pauses.length
    ? pauses
        .map((pause) => `${pause.reason || 'Interrupção'} (${formatTimerDuration(pause.durationMs || 0)})`)
        .join(', ')
    : 'Sem pausas registradas';

  const plannedLabel = Number(timer?.durationMinutes) > 0
    ? `${timer.durationMinutes} min`
    : 'Livre';

  return [
    `[Foco] Sessão encerrada por ${currentUserName || 'usuário'}.`,
    `Planejado: ${plannedLabel}.`,
    `Tempo em foco: ${formatTimerDuration(snapshot.elapsedMs)}.`,
    `Pausas: ${pausesSummary}.`
  ].join(' ');
}
